import React from 'react';
import './WhyGemco.css';
import { CiSettings } from "react-icons/ci";
import { FaAward } from "react-icons/fa6";
import { FiPackage } from "react-icons/fi";
import { FaUsers } from "react-icons/fa";
import Img1 from '../../../Gemco-Website-Images/Homepage/HP-05-w5-img-1.jpg';
import Img2 from '../../../Gemco-Website-Images/Homepage/HP-06-w5-img-2.jpg';
import Img3 from '../../../Gemco-Website-Images/Homepage/HP-07-w5-img-3.jpg';
import Img4 from '../../../Gemco-Website-Images/Homepage/HP-07-w5-img-4.jpg';

const WhyGemco = () => {
      
  return (
    <div className='container whygemco'>
        <h1>WHY GEMCO ?</h1>
        <div className="wp_why_heading">
            <h1>What Makes Us Different</h1>
        </div>
        <div className="bs-work-wrap">
            <div className="card wp_why_card">
                <img decoding="async" src={Img1} height="250" />
                <div className="card-body">
                    <div className="wp_card-title"><span className='card-icons'><CiSettings size={32} /></span>Deep Specialisation</div>
                    <div className="wp_card-text">CHW, district cooling and precision MEP expertise built over 25 years — trusted for the most technically demanding scopes in the UAE.</div>
                </div>
            </div>
            <div className="card wp_why_card">
                <img decoding="async" src={Img2} height="250" />
                <div className="card-body">
                    <div className="wp_card-title"> <span className='card-icons' ><FaAward size={32} /></span>Proven on Landmark Projects</div>
                    <div className="wp_card-text">Trusted by UAE's leading MEP contractors on Wynn Al Marjan Island, Museum of the Future, Bvlgari Hotel and Dubai Airport.</div>
                </div>
            </div>
            <div className="card wp_why_card">
                <img decoding="async" src={Img3} height="250" />
                <div className="card-body">
                    <div className="wp_card-title"><span className='card-icons' ><FiPackage size={32}  /></span>Full Supply & Installation</div>
                    <div className="wp_card-text">Complete MEP scope from procurement to commissioning — for direct clients and major contractors alike.</div>
                </div>
            </div>
            <div className="card wp_why_card">
                <img decoding="async" src={Img4} height="250" />
                <div className="card-body">
                    <div className="wp_card-title"><span className='card-icons' ><FaUsers size={32}  /></span>Client-First Delivery</div>
                    <div className="wp_card-text">On time, on scope, with full technical accountability. Every project — large or small — gets our full attention.</div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default WhyGemco